import { Action } from '@ngrx/store';

export enum EThemeActions {
  SetTheme = '[Theme] Set',
  InitTheme = '[Theme] Init',
}

export class SetTheme implements Action {
  public readonly type = EThemeActions.SetTheme;

  constructor(public theme: string) {}
}

export class InitTheme implements Action {
  public readonly type = EThemeActions.InitTheme;
}

export type ThemeActions = SetTheme | InitTheme;
